import React, { FC } from 'react';
import styles from './TableOptions.module.scss';
import { reorder } from '../../AnnotationManager/Annotations/gridSelector';
import { CheckboxValueType } from 'antd/lib/checkbox/Group';
import classNames from 'classnames';
import { Checkbox } from 'antd';
import { DragDropContext, Droppable, Draggable, DropResult, DraggableProvided, DraggableStateSnapshot } from 'react-beautiful-dnd';
import { PauseOutlined } from '@ant-design/icons';
import { motion } from 'framer-motion';
import { fadein, item } from '../../Shared/Motion';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import ReactDOM from 'react-dom';
import { SimpleColumn } from './types';

type Props = {
  anyShown: boolean;
  toHideColumns: string[];
  selectedColumns: SimpleColumn[];
  setSelectedColumns: (columns: SimpleColumn[]) => void;
  toHideColumnsSelected: (checkedValues: CheckboxValueType[]) => void;
};
const portal: HTMLElement = document.createElement('div');
document.body.appendChild(portal);

const VisibleColumns: FC<Props> = ({ anyShown, toHideColumns, selectedColumns, setSelectedColumns, toHideColumnsSelected }) => {
  const onDragEnd = (result: DropResult) => {
    if (!result.destination) {
      return;
    }

    if (result.destination.index === result.source.index) {
      return;
    }

    const newOrder = reorder(selectedColumns, result.source.index, result.destination.index);

    setSelectedColumns(newOrder);
  };

  const selectAll = (e: CheckboxChangeEvent) => {
    if (e.target.checked) {
      const all = selectedColumns.map(x => x.key);
      toHideColumnsSelected(all);
    } else {
      toHideColumnsSelected([]);
    }
  };

  const getCard = (provided: DraggableProvided, snapshot: DraggableStateSnapshot, column: SimpleColumn) => {
    const card = (
      <div
        className={classNames(styles.orderableCard, {
          [styles.inPortal]: snapshot.isDragging
        })}
        ref={provided.innerRef}
        {...provided.draggableProps}
        {...provided.dragHandleProps}
      >
        <Checkbox value={column.key}>{column.title}</Checkbox>
        <PauseOutlined rotate={90} />
      </div>
    );

    if (!snapshot.isDragging) {
      return card;
    }

    return ReactDOM.createPortal(card, portal);
  };

  return (
    <motion.div initial='hidden' animate='visible' variants={fadein}>
      <h5 className={styles.columnTitle}>Visible Columns</h5>
      <motion.div className={styles.columnsActions}>
        <Checkbox onChange={selectAll} checked={toHideColumns.length === selectedColumns.length}>
          Select All
        </Checkbox>
      </motion.div>
      <motion.div
        className={classNames(styles.columnsBox, {
          [styles.emptyBox]: !anyShown
        })}
      >
        {!anyShown && <span>Nothing is shown</span>}
        {anyShown && (
          <Checkbox.Group value={toHideColumns} style={{ width: '100%' }} onChange={toHideColumnsSelected}>
            <DragDropContext onDragEnd={onDragEnd}>
              <Droppable droppableId='list'>
                {provided => (
                  <div ref={provided.innerRef} {...provided.droppableProps}>
                    {selectedColumns.map((column: SimpleColumn, index) => (
                      <motion.div variants={item}>
                        <Draggable key={column.key} draggableId={column.key} index={index}>
                          {(provided, snapshot) => getCard(provided, snapshot, column)}
                        </Draggable>
                      </motion.div>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          </Checkbox.Group>
        )}
      </motion.div>
    </motion.div>
  );
};

export default VisibleColumns;
